import type {CodeListId} from './types';

export const mockCodeLists: CodeListId[] = [
  // 'EXPRESSION_FORMAT',
  // 'EXPRESSION_CONTENT',
  // 'COLOUR',
  // 'GENDER',
  // 'LANGUAGE',
  // 'PRODUCT_FORM',
  // 'EXPRESSION_ROLE_TYPE',
  'manifestation_role_type',
  'collection_type',
  'PRIZE_TYPE',
  'work_collection_type',
  'product_form_simple_values',
  'availability_status',
  'task_type',
  'media_sub_type',
  'WORK_TITLE_TYPE',
  'WORK_TYPE',
  'MONTH',
  'bulkUpdateWorkField',
  'bulkUpdateAction',
  'bulkUpdateStatus',
  'bulkUpdateType',
  'DUMMY', // TODO: Used for "role" for linked agent link (no role), remove when general LinkedEntity is implemented (i.e. only link and not other properties like role, series number, etc)
];
